<template>
  <tr>
    <td>{{ item.title }}</td>
    <td>{{ code }}</td>
    <td>
      <span v-bind:style="{ color: groupColor }">{{ groupTitle }}</span>
    </td>
    <td>{{ item.price | currency }}</td>
    <td>{{ item.initialScopeOfWork }}</td>
    <td class="text-right">
      <version-tooltip :version="item.version">
        <v-btn flat icon isEditMode="black lighten-2" class="mr-0" @click="handleEditClickButton">
          <v-icon small>fas fa-pencil-alt</v-icon>
        </v-btn>
      </version-tooltip>
      <v-btn flat icon color="black lighten-2" class="ml-0" @click="handleDeleteButtonClick">
        <v-icon small>fas fa-trash-alt</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import api from '../../api'
import {showApiError} from '../../helpers/notification'
import {isNumeric} from '../../helpers/types'
import {validateStringLength} from '../../helpers/validation'
import VersionTooltip from '../Ui/VersionTooltip'
import _ from 'lodash'

export default {
  name: 'service-item',
  props: {
    item: {
      type: Object
    }
  },
  components: {
    VersionTooltip
  },
  filters: {},
  data () {
    return {
      validatableRefs: ['title', 'code', 'price'],
      draft: {
        id: this.item.id,
        title: this.item.title,
        code: this.item.code,
        groupId: this.item.groupId,
        price: this.item.price,
        initialScopeOfWork: this.item.initialScopeOfWork
      },
      titleRules: [
        v => !!v || 'Enter service title',
        v => (v && v.length <= 1000) || 'The length of the name should be no more than 1000 characters'
      ],
      codeRules: [
        v => !!v || 'Enter service code',
        v => (v && v.length <= 255) || 'Service code must be no more than 255 characters'
      ],
      initialScopeOfWorkRules: [
        _.partial(validateStringLength, _, 2000, 'The length of the initial scope of work should be no more than 2000 characters')
      ],
      priceRules: [
        (value) => {
          let numeric = isNumeric(value)

          if (!numeric) {
            return 'Price must be numeric value'
          }

          if (parseFloat(value) < 0) {
            return 'Price value must be positive or zero'
          }

          return true
        }
      ]
    }
  },
  beforeCreate () {

  },
  computed: {
    ...mapState({
      availableServiceGroups: 'availableServiceGroups'
    }),
    ...mapGetters({
      availableServiceGroupsById: 'availableServiceGroupsById'
    }),
    title: {
      get: function () {
        return this.item.title
      },
      set: function (newValue) {
        this.draft.title = newValue
      }
    },
    code: {
      get: function () {
        return this.item.code
      },
      set: function (newValue) {
        this.draft.code = newValue
      }
    },
    group: {
      get: function () {
        return this.item.groupId
      },
      set: function (newValue) {
        this.draft.groupId = newValue
      }
    },
    price: {
      get: function () {
        return this.item.price
      },
      set: function (newValue) {
        this.draft.price = newValue
      }
    },
    initialScopeOfWork: {
      get: function () {
        return this.item.initialScopeOfWork
      },
      set: function (newValue) {
        if (newValue.length === 0) {
          this.draft.initialScopeOfWork = null
          return
        }
        this.draft.initialScopeOfWork = newValue
      }
    },
    groupColor () {
      return _.get(this.availableServiceGroupsById, [this.item.groupId, 'colorScheme'], '#000000')
    },
    groupTitle () {
      return _.get(this.availableServiceGroupsById, [this.item.groupId, 'title'], '-')
    }
  },
  watch: {},
  mounted () {
  },
  methods: {
    handleEditClickButton () {
      this.$emit('edited', this.item)
    },
    async handleDeleteButtonClick () {
      if (!confirm('Do you want to remove service with title: "' + this.item.title + '"')) {
        return
      }

      try {
        await api.deleteService(this.item)
        this.$emit('deleted', this.item)
      } catch (e) {
        showApiError(this, e, 'Unable to delete client')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/ServiceItem.vue